import http from '@/api/http'

import { TGetFilesParams, TGetFilesResponse, TProcessingUser } from './types'

export const getFiles = async (filters: TGetFilesParams) => {
  const response = await http.get<TGetFilesResponse>('prediction-processing/', {
    params: filters,
  })
  return response.data
}

export const getProcessingUsers = async () => {
  const response = await http.get<TProcessingUser[]>(
    'prediction-processing/field-values/users/'
  )
  return response.data
}
